import { useState, useRef } from 'react';
import './CareersPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatBot from '../components/ChatBot';

const DEPARTMENTS = [
  { id: 'marketing',   label: 'Marketing',          desc: 'PPC · SEO · Social',       icon: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
    </svg>
  )},
  { id: 'webdev',      label: 'Web Development',    desc: 'React · Shopify · CMS',     icon: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
    </svg>
  )},
  { id: 'marketplace', label: 'Marketplace Ops',    desc: 'Amazon · Flipkart · Noon',  icon: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
    </svg>
  )},
  { id: 'content',     label: 'Content & Social',   desc: 'Reels · Blogs · Copy',      icon: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
    </svg>
  )},
  { id: 'design',      label: 'Design',             desc: 'Brand · UI/UX · Motion',    icon: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="13.5" cy="6.5" r=".5"/><circle cx="17.5" cy="10.5" r=".5"/><circle cx="8.5" cy="7.5" r=".5"/><circle cx="6.5" cy="12.5" r=".5"/>
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
    </svg>
  )},
  { id: 'operations',  label: 'Operations',         desc: 'Logistics · Fulfillment',   icon: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  )},
];

const ROLES = {
  marketing:   ['Performance Marketing Manager', 'SEO Specialist', 'Email & WhatsApp Marketing', 'Influencer Marketing Coordinator', 'Brand Strategy Lead'],
  webdev:      ['Frontend Developer (React)', 'Shopify Developer', 'Full-Stack Developer', 'WordPress / CMS Developer'],
  marketplace: ['Amazon Account Manager', 'Flipkart Specialist', 'International Marketplace Analyst', 'Quick Commerce Operations', 'Noon / eBay / AliExpress Specialist'],
  content:     ['Content Writer', 'Social Media Manager', 'Video Editor / Reels Creator', 'Copywriter'],
  design:      ['Graphic Designer', 'UI/UX Designer', 'Motion Designer', 'Brand Identity Designer'],
  operations:  ['Logistics Coordinator', 'Supply Chain Analyst', 'Returns & Fulfillment Manager', 'Warehousing Specialist'],
};

const EXPERIENCE_LEVELS = [
  'Fresher (0–1 year)',
  '1–2 years',
  '2–4 years',
  '4–7 years',
  '7+ years',
];

const EMPTY_FORM = {
  department: '',
  role: '',
  name: '',
  email: '',
  whatsapp: '',
  experience: '',
  portfolio: '',
  message: '',
  resume: null,
};

export default function CareersPage() {
  const [form, setForm]       = useState(EMPTY_FORM);
  const [status, setStatus]   = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({
      ...f,
      [name]: value,
      ...(name === 'department' ? { role: '' } : {}),
    }));
  };

  const handleFile = (file) => {
    if (!file) return;
    const allowed = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];
    if (!allowed.includes(file.type)) {
      setErrorMsg('Please upload a PDF or Word document (.pdf, .doc, .docx).');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setErrorMsg('File must be under 5 MB.');
      return;
    }
    setErrorMsg('');
    setForm(f => ({ ...f, resume: file }));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFile(e.dataTransfer.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.department || !form.role) {
      setErrorMsg('Please select a department and specific role.');
      return;
    }
    setStatus('sending');
    setErrorMsg('');

    const payload = new FormData();
    payload.append('name',       form.name);
    payload.append('email',      form.email);
    payload.append('whatsapp',   form.whatsapp);
    payload.append('department', form.department);
    payload.append('role',       form.role);
    payload.append('experience', form.experience || '');
    payload.append('portfolio',  form.portfolio  || '');
    payload.append('message',    form.message);
    if (form.resume) payload.append('resume', form.resume, form.resume.name);

    try {
      const res  = await fetch('/api/careers.php', { method: 'POST', body: payload });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
      } else {
        setErrorMsg(data.message || 'Something went wrong. Please try again.');
        setStatus('error');
      }
    } catch {
      setErrorMsg('Network error. Please check your connection and try again.');
      setStatus('error');
    }
  };

  const reset = () => { setForm(EMPTY_FORM); setStatus('idle'); setErrorMsg(''); };

  const availableRoles = form.department ? ROLES[form.department] : [];

  return (
    <>
      <div className="cr-wrapper">
        <Header />

        {/* ── Hero ── */}
        <div className="cr-hero">
          <div className="cr-hero-glow cr-hero-glow--a" />
          <div className="cr-hero-glow cr-hero-glow--b" />
          <div className="cr-hero-inner">
            <div className="cr-hero-badge">WE'RE HIRING</div>
            <h1 className="cr-hero-title">
              Join the{' '}
              <span className="cr-hero-accent">Mad Marketing Club</span>
            </h1>
            <p className="cr-hero-sub">
              We're a fast-growing e-commerce growth agency based in Pune.
              Come build the future of Indian and global commerce with us.
            </p>
            <div className="cr-stats">
              <div className="cr-stat">
                <span className="cr-stat-num">50+</span>
                <span className="cr-stat-label">Brands Served</span>
              </div>
              <div className="cr-stat-divider" />
              <div className="cr-stat">
                <span className="cr-stat-num">12+</span>
                <span className="cr-stat-label">Marketplaces</span>
              </div>
              <div className="cr-stat-divider" />
              <div className="cr-stat">
                <span className="cr-stat-num">Pune</span>
                <span className="cr-stat-label">HQ + Remote</span>
              </div>
            </div>
          </div>
        </div>

        {/* ── Form section ── */}
        <div className="cr-form-section">
          <div className="cr-form-card">

            {status === 'success' ? (
              <div className="cr-success">
                <div className="cr-success-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                    stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <h3 className="cr-success-title">Application Received!</h3>
                <p className="cr-success-desc">
                  Thanks, <strong>{form.name}</strong>! We've received your application for{' '}
                  <strong>{form.role}</strong> and will be in touch within 3–5 business days.
                </p>
                <button className="cr-submit-btn" onClick={reset}>Apply for Another Role</button>
              </div>
            ) : (
              <form className="cr-form" onSubmit={handleSubmit} noValidate>

                {/* ── Section 1: Role ── */}
                <div className="cr-section">
                  <div className="cr-section-hd">
                    <span className="cr-section-num">01</span>
                    <div>
                      <h3 className="cr-section-title">What are you applying for?</h3>
                      <p className="cr-section-desc">Choose the department that best fits your skills.</p>
                    </div>
                  </div>

                  <div className="cr-dept-grid">
                    {DEPARTMENTS.map(dept => (
                      <button
                        key={dept.id}
                        type="button"
                        className={`cr-dept-card${form.department === dept.id ? ' cr-dept-card--active' : ''}`}
                        onClick={() => setForm(f => ({ ...f, department: dept.id, role: '' }))}
                      >
                        <span className="cr-dept-icon">{dept.icon}</span>
                        <span className="cr-dept-label">{dept.label}</span>
                        <span className="cr-dept-desc">{dept.desc}</span>
                      </button>
                    ))}
                  </div>

                  {form.department && (
                    <div className="cr-field cr-field--mt">
                      <label className="cr-label" htmlFor="cr-role">Specific Role *</label>
                      <select
                        id="cr-role" name="role"
                        className="cr-input cr-select"
                        value={form.role} onChange={handleChange} required
                      >
                        <option value="">Select a role…</option>
                        {availableRoles.map(r => <option key={r} value={r}>{r}</option>)}
                      </select>
                    </div>
                  )}
                </div>

                <div className="cr-divider" />

                {/* ── Section 2: About You ── */}
                <div className="cr-section">
                  <div className="cr-section-hd">
                    <span className="cr-section-num">02</span>
                    <div>
                      <h3 className="cr-section-title">About You</h3>
                      <p className="cr-section-desc">Your contact details — we'll reach out here.</p>
                    </div>
                  </div>

                  <div className="cr-row">
                    <div className="cr-field">
                      <label className="cr-label" htmlFor="cr-name">Full Name *</label>
                      <input
                        id="cr-name" name="name" type="text" className="cr-input"
                        placeholder="Priya Sharma"
                        value={form.name} onChange={handleChange} required
                      />
                    </div>
                    <div className="cr-field">
                      <label className="cr-label" htmlFor="cr-email">Email Address *</label>
                      <input
                        id="cr-email" name="email" type="email" className="cr-input"
                        placeholder="you@example.com"
                        value={form.email} onChange={handleChange} required
                      />
                    </div>
                  </div>

                  <div className="cr-row">
                    <div className="cr-field">
                      <label className="cr-label" htmlFor="cr-whatsapp">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"
                          style={{ verticalAlign: 'middle', marginRight: 5 }}>
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
                        </svg>
                        WhatsApp Number *
                      </label>
                      <input
                        id="cr-whatsapp" name="whatsapp" type="tel" className="cr-input"
                        placeholder="+91 98765 43210"
                        value={form.whatsapp} onChange={handleChange} required
                      />
                    </div>
                    <div className="cr-field">
                      <label className="cr-label" htmlFor="cr-experience">Years of Experience</label>
                      <select
                        id="cr-experience" name="experience"
                        className="cr-input cr-select"
                        value={form.experience} onChange={handleChange}
                      >
                        <option value="">Select experience level…</option>
                        {EXPERIENCE_LEVELS.map(l => <option key={l} value={l}>{l}</option>)}
                      </select>
                    </div>
                  </div>

                  <div className="cr-field">
                    <label className="cr-label" htmlFor="cr-portfolio">Portfolio / LinkedIn / GitHub URL</label>
                    <input
                      id="cr-portfolio" name="portfolio" type="url" className="cr-input"
                      placeholder="https://yourportfolio.com or linkedin.com/in/yourname"
                      value={form.portfolio} onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="cr-divider" />

                {/* ── Section 3: Cover Letter ── */}
                <div className="cr-section">
                  <div className="cr-section-hd">
                    <span className="cr-section-num">03</span>
                    <div>
                      <h3 className="cr-section-title">Why MMC?</h3>
                      <p className="cr-section-desc">Tell us what excites you and what you'd bring to the team.</p>
                    </div>
                  </div>
                  <div className="cr-field">
                    <label className="cr-label" htmlFor="cr-message">Cover Letter *</label>
                    <textarea
                      id="cr-message" name="message"
                      className="cr-input cr-textarea"
                      placeholder="Introduce yourself, highlight your relevant experience, and tell us why you'd be a great fit for MMC…"
                      rows={6}
                      value={form.message} onChange={handleChange} required
                    />
                  </div>
                </div>

                <div className="cr-divider" />

                {/* ── Section 4: Resume ── */}
                <div className="cr-section">
                  <div className="cr-section-hd">
                    <span className="cr-section-num">04</span>
                    <div>
                      <h3 className="cr-section-title">Your Resume</h3>
                      <p className="cr-section-desc">Upload your CV or resume — PDF or Word, max 5 MB.</p>
                    </div>
                  </div>

                  <div
                    className={`cr-upload${dragOver ? ' cr-upload--drag' : ''}${form.resume ? ' cr-upload--done' : ''}`}
                    onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                    onDragLeave={() => setDragOver(false)}
                    onDrop={handleDrop}
                    onClick={() => fileRef.current?.click()}
                  >
                    <input
                      ref={fileRef}
                      type="file"
                      accept=".pdf,.doc,.docx"
                      style={{ display: 'none' }}
                      onChange={(e) => handleFile(e.target.files[0])}
                    />
                    {form.resume ? (
                      <>
                        <div className="cr-upload-icon cr-upload-icon--done">
                          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                        </div>
                        <p className="cr-upload-filename">{form.resume.name}</p>
                        <p className="cr-upload-hint">Click to replace</p>
                      </>
                    ) : (
                      <>
                        <div className="cr-upload-icon">
                          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="17 8 12 3 7 8"/>
                            <line x1="12" y1="3" x2="12" y2="15"/>
                          </svg>
                        </div>
                        <p className="cr-upload-text">
                          Drag & drop your resume, or <span>click to browse</span>
                        </p>
                        <p className="cr-upload-hint">PDF, DOC, DOCX — up to 5 MB</p>
                      </>
                    )}
                  </div>
                </div>

                {/* ── Error ── */}
                {(status === 'error' || errorMsg) && (
                  <div className="cr-error">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="12" y1="8" x2="12" y2="12"/>
                      <line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    {errorMsg || 'Something went wrong. Please try again.'}
                  </div>
                )}

                {/* ── Submit ── */}
                <div className="cr-footer">
                  <button
                    type="submit"
                    className={`cr-submit-btn${status === 'sending' ? ' cr-submit-btn--loading' : ''}`}
                    disabled={status === 'sending'}
                  >
                    {status === 'sending' ? (
                      <>
                        <span className="cr-spinner" />
                        Submitting…
                      </>
                    ) : (
                      <>
                        Submit Application
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="5" y1="12" x2="19" y2="12"/>
                          <polyline points="12 5 19 12 12 19"/>
                        </svg>
                      </>
                    )}
                  </button>
                  <p className="cr-privacy">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                    Your information is private and will never be shared.
                  </p>
                </div>
              </form>
            )}
          </div>
        </div>

        <ChatBot />
      </div>
      <Footer />
    </>
  );
}
